import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "home",
  id: "homePage",
  style: {
    "min-width": "1560px"
  }
};
const _hoisted_2 = {
  key: 0,
  class: "hometitle gloria-font"
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  key: 2,
  class: "googleMaps"
};
const _hoisted_5 = {
  key: 3,
  class: "accordion"
};
const _hoisted_6 = {
  key: 4,
  class: "lowCode"
};
const _hoisted_7 = {
  key: 0,
  class: "mediumList"
};
const _hoisted_8 = {
  class: "mediumBody"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  style: {
    "width": "100%",
    "height": "310px",
    "overflow": "hidden",
    "border-radius": "10px",
    "margin-bottom": "20px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center"
  }
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "nr"
};
const _hoisted_13 = {
  key: 5,
  class: "subscription"
};
const _hoisted_14 = {
  key: 6,
  class: "richText"
};
const _hoisted_15 = {
  key: 7,
  class: "fit-up-item"
};
const _hoisted_16 = {
  key: 8,
  class: "fit-up-item"
};
const _hoisted_17 = {
  key: 9,
  class: "fit-up-item"
};
const _hoisted_18 = {
  key: 10
};
const _hoisted_19 = {
  key: 11,
  class: "fit-up-item"
};
const _hoisted_20 = {
  key: 12,
  class: "goods-list fit-up-item"
};
const _hoisted_21 = {
  key: 13,
  class: "fit-up-item"
};
const _hoisted_22 = {
  key: 14,
  class: "fit-up-item"
};
const _hoisted_23 = {
  style: {
    "margin": "100px 0"
  }
};
const _hoisted_24 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "position": "relative"
  }
};
const _hoisted_25 = {
  class: "target-top",
  style: {
    "overflow": "hidden"
  }
};
const _hoisted_26 = {
  class: "target-img"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = {
  class: "target-img img-right"
};
const _hoisted_29 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_imageText = _resolveComponent("imageText");
  const _component_googleMaps = _resolveComponent("googleMaps");
  const _component_accordion = _resolveComponent("accordion");
  const _component_lowCode = _resolveComponent("lowCode");
  const _component_subscription = _resolveComponent("subscription");
  const _component_richText = _resolveComponent("richText");
  const _component_imgSwipers = _resolveComponent("imgSwipers");
  const _component_images = _resolveComponent("images");
  const _component_videos = _resolveComponent("videos");
  const _component_goodsScroll = _resolveComponent("goodsScroll");
  const _component_navigation = _resolveComponent("navigation");
  const _component_goodsGrid = _resolveComponent("goodsGrid");
  const _component_texts = _resolveComponent("texts");
  const _component_hotMap = _resolveComponent("hotMap");
  const _component_why_m = _resolveComponent("why_m");
  return $setup.Client == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.get_data, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "assembly"
    }, [item.base.title ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(item.base.title), 1)])) : _createCommentVNode("", true), item.name === 'imageText' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_imageText, {
      data: item,
      imageTextIndex: index
    }, null, 8, ["data", "imageTextIndex"])])) : _createCommentVNode("", true), item.name === 'googleMaps' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_googleMaps, {
      gMaps: item
    }, null, 8, ["gMaps"])])) : _createCommentVNode("", true), item.name === 'accordion' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_accordion, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'lowCode' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [item.data === '<mediumList>' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[2] || (_cache[2] = _createElementVNode("h1", null, "米檬最新资讯", -1)), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list.length <= 3 ? $setup.list : 3, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "mediumImte",
        onClick: $event => $setup.details($setup.list.length <= 3 ? item.id : $setup.list[index].id)
      }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
        src: $setup.list.length <= 3 ? item.imgUrl : $setup.list[index].imgUrl,
        alt: "",
        style: {
          "width": "100%",
          "height": "100%",
          "object-fit": "cover"
        }
      }, null, 8, _hoisted_11)]), _createElementVNode("h3", null, _toDisplayString($setup.list.length <= 3 ? item.title : $setup.list[index].title), 1), _createElementVNode("span", _hoisted_12, _toDisplayString($setup.list.length <= 3 ? item.brief : $setup.list[index].brief), 1), _cache[1] || (_cache[1] = _createElementVNode("span", {
        style: {
          "font-size": "15px",
          "color": "#31AFC7"
        }
      }, "了解详情", -1))], 8, _hoisted_9);
    }), 256))]), _createElementVNode("img", {
      src: "https://www.mimodental.com/assets/imgData/imgs/tjkf.png",
      style: {
        "width": "230px",
        "cursor": "pointer"
      },
      onClick: _cache[0] || (_cache[0] = (...args) => $setup.call && $setup.call(...args)),
      alt: ""
    })])) : (_openBlock(), _createBlock(_component_lowCode, {
      key: 1,
      data: item
    }, null, 8, ["data"]))])) : _createCommentVNode("", true), item.name === 'subscription' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_subscription, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'richText' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_richText, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'slider' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_imgSwipers, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'images' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_images, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'video' ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_videos, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'goodsScroll' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_goodsScroll, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'navigation' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_navigation, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'goodsGrid' ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_goodsGrid, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'text' ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_texts, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'hotmap' ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_hotMap, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true)]);
  }), 128)), _createElementVNode("div", _hoisted_23, [_cache[5] || (_cache[5] = _createElementVNode("div", {
    style: {
      "text-align": "center",
      "margin": "30px 0"
    }
  }, [_createElementVNode("h1", {
    style: {
      "color": "#10A6C4",
      "margin-bottom": "10px",
      "font-size": "50px"
    }
  }, "携手全球著名口腔品牌 将科技融入智慧看牙")], -1)), _createElementVNode("div", _hoisted_24, [_cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "left_gradient"
  }, null, -1)), _cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "right_gradient"
  }, null, -1)), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, item => {
    return _createElementVNode("div", null, [_createElementVNode("img", {
      src: 'https://www.mimodental.com/assets/imgData/img/why/' + item + '.png',
      style: {
        "width": "400px",
        "object-fit": "cover"
      }
    }, null, 8, _hoisted_27)]);
  }), 64))]), _createElementVNode("div", _hoisted_28, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, item => {
    return _createElementVNode("div", null, [_createElementVNode("img", {
      src: 'https://www.mimodental.com/assets/imgData/img/why/' + item + '.png',
      style: {
        "width": "400px",
        "object-fit": "cover"
      }
    }, null, 8, _hoisted_29)]);
  }), 64))])])])])])) : (_openBlock(), _createBlock(_component_why_m, {
    key: 1
  }));
}